var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 53.7C88.5 47.1 86.8 42 85.4 39C81.6 30.1 74.4 23 65.5 19.1C65.5 19.1 65.4 19 65.3 19C48.8 11.6 31 16.5 20.8 29.3C15 36 11.5 44.9 11.5 54.6C11.5 59.9 12.6 65 14.6 69.6C14.7 69.8 14.7 70 14.8 70.2C16.6 74.6 19 77.7 20.8 79.5C23.6 82.7 26.9 85.5 30.6 87.6C37.9 92.2 46 93.9 54.8 92.6C60.5 91.9 65.8 90 70.5 87C76.9 83.2 81.7 77.7 84.8 70.8C87.2 65.6 88.5 59.8 88.5 53.7Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9 7.70001C44.8 7.20001 45.5 6.80001 45.9 7.20001C70 31.1 73.8 41.2 73.4 54.4C73 66.4 61.7 77.3 49.4 77.3C37.1 77.3 27 67.8 27.4 56.7C28.2 31.4 47 27.9 44.9 7.70001Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4 33.3C61.8 47.4 64 53.2 63.8 60.9C63.5 67.8 57.1 74 50 74C43 74 37.2 68.6 37.4 62.2C38 47.4 49.3 45.7 47.4 33.3Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasSecondary);
export default __webpack_public_path__ + "static/media/gas-secondary.d78798123a678c10c7bc377add8cc23f.svg";
export { ForwardRef as ReactComponent };